// The slot the traveller picked is the date the operator checks ages against. The itinerary's own
// startDateTime is derived from that slot on the server, so a tour added in this session carries no
// usable value and everyone would be aged as of today instead.
const getTourTravelDate = (tourItinerary) =>
  tourItinerary?.selectedSlot?.date || tourItinerary?.startDateTime || null;

export default getTourTravelDate;
